import React, { Component } from 'react';
import { connect } from 'react-redux';
import { t } from '../../../../../locales';
import { postRnDeeplinkAction } from '../../../../../utils/AppUtils';
import { AXA_GOAL_INSURED_SHARE } from '../../../../emma-customer-profile/actions/modalAction';
import DashboardCardScenario from '../index';
import img from '../../../../../assets/images/vhis/dashboard/ico-pending@3x.png';

interface ScenarioReminderProps {
  showInsuredShare: () => void;
}

class ScenarioReminder extends Component<ScenarioReminderProps> {
  render() {
    const props = {
      imageIcon: img,
      text: t('AXA_GOAL_SCENAVIO_REMINDER_TEXT'),
      buttonText: t('AXA_GOAL_SCENAVIO_REMINDER_BUTTON_TEXT'),
      clickButton: () => {
        // sharing in mobile
        const result = postRnDeeplinkAction({
          host: 'emma-common/shareTemplate',
          query: {
            templateId: 'axaGoalInsuredInvitation',
          },
        });
        if (!result) {
          // handle web behaviour
          const { showInsuredShare } = this.props;
          showInsuredShare();
        }
      },
    };
    return <DashboardCardScenario {...props} />;
  }

  static mapStateToProps(state: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      showInsuredShare: () =>
        dispatch({
          type: AXA_GOAL_INSURED_SHARE,
        }),
    };
  }
}

export default connect(
  ScenarioReminder.mapStateToProps,
  ScenarioReminder.mapDispatchToProps,
)(ScenarioReminder);
